export enum EnumEcomActionType{
    VisitProductDetails = 'detail',
    AddProductToBasket = 'add',
    RemoveProductFromBasket = 'remove',
    NewOrder = 'purchase'
}